import axios from "../../config/axiosConfig";

export default class RealisationService {
  getAllActiveRealisation = async () => {
    try {
      const response = await axios.get("blogs/blogs/active");
      return response;
    } catch (error) {
      console.error("Error fetching active blogs:", error);
      throw new Error(
        "Erreur lors de la récupération des blogs : " + (error.message || "Network Error")
      );
    }
  };
  getAllRealisation = async () => {
    try {
      const response = await axios.get("blogs");
      return response;
    } catch (error) {
      console.error("Error fetching blogs:", error);
      throw new Error(
        "Erreur lors de la récupération des blogs : " + (error.message || "Network Error")
      );
    }
  };
  createRealisation = async (data) => {
    try {
      const response = await axios.post("/blogs", data);
      return response.data;
    } catch (error) {
      console.error("Error creating blog:", error);
      throw new Error(
        "Erreur lors de la création du blog : " + (error.message || "Network Error")
      );
    }
  };
  toggleRStatus = async (id, data) => {
    try {
      const response = await axios.put(`/blogs/${id}/toggle`, data);
      return response.data;
    } catch (error) {
      console.error("Error toggling blog status:", error);
      throw new Error(
        "Erreur lors de la modification du statut : " + (error.message || "Network Error")
      );
    }
  };
  getRealisationById = async (id) => {
    try {
      const response = await axios.get(`/blogs/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching blog by id:", error);
      throw new Error("Erreur lors de la récupération du blog : " + (error.message || "Network Error"));
    }
  };
  getRealisationBySlug = async (slug) => {
    try {
      const response = await axios.get(`/blogs/${slug}/blog`);
      return response;
    } catch (error) {
      console.error("Error fetching blog by slug:", error);
      throw new Error("Erreur lors de la récupération du blog : " + (error.message || "Network Error"));
    }
  };
  updateRealisation = async (id, data) => {
    try {
      const response = await axios.put(`/blogs/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating blog:", error);
      throw new Error(
        "Erreur lors de la modification du blog : " + (error.message || "Network Error")
      );
    }
  };
}
